<template>
  <v-container
    class="cmp-settings-sharing-settings dt-sidewindow submodule-root"
  >
    <div class="dt-tabs-container submodule-root">
      <glayout
        :tabs="sharingSettingsTabs"
        :loading="sharingSettingsData && sharingSettingsData.loading"
        tabPanelColor="secondary"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('partner_links')">
                <PartnerLink/>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="api_key">
          <grow>
            <gcol>
              <gbox :title="$t('api_key')">
                <ApiKey
                  v-if="sharingSettingsData"
                  :clientName="clientName"
                  :sharingSettingsData="sharingSettingsData"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="open_apis">
          <grow>
            <gcol>
              <gbox :title="$t('open_apis')">
                <OpenAPI
                  v-if="sharingSettingsData"
                  :clientName="clientName"
                  :sharingSettingsData="sharingSettingsData"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
  </v-container>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import DList from "@dtplugins/list/dlist";
import * as ActionTypes from "../../store/types";
import { mapActionObject } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { mapGetters } from "vuex";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import QuickModal from "@plugins/quickmodal/quickmodal";
import { createFields } from "../../../../plugins/quickmodal";
import ModalContainer from "@dtplugins/modal/modal-container";
import {
  createTextFieldConfig,
  EventHooks
} from "../../../../plugins/text-field";
import { JSONX, snakeCaseToWords } from "../../../../utility";
import { LoadingUI } from "@plugins/loading/loading";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import DTable from "@dtplugins/dtable/dtable";
import NTable from "@/plugins/datatable/datatable";
import Ddropzone from "@dtplugins/dbox/dropzone";
import { createNTableConfig } from "../../../../plugins/datatable";
import { sharingSettingsActions } from "../../store/sharing/actions";
import { dHeaders, DHeaderTypes } from "../../../../dt-plugins/dtable";
import { MHTTPCL, clientName } from "../../../../services/http/http-client";
import { isNegative } from "../../../../utility/fp";
import {
  createForms,
  createForm
} from "../../../../plugins/form-builder/form.model";
import PartnerLink from "./partner-link";
import RSSFeed from "./rss-feed";
import ApiKey from "./api-key";
import OpenAPI from "./open-api";

export default {
  components: {
    DBox,
    DList,
    DTable,
    QuickModal,
    ModalContainer,
    LoadingUI,
    NTable,
    Ddropzone,
    PartnerLink,
    RSSFeed,
    ApiKey,
    OpenAPI
  },
  mounted: function() {
    this.fetchData();
    console.log(clientName);
  },
  data: function() {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur
      }),

      selectedTaxGroup: null,
      clientName: clientName
    };
    //MARK: Data Function
  },
  mixins: [createDTGridHost()],
  computed: {
    ...mapGetters(storeNS, {
      sharingSettingsData: "sharingSettingsData"
    }),
    sharingSettingsTabs: function() {
      return [
        {
          route: "overview",
          value: this.$t("overview") // Tab Name
        },
        {
          route: "api_key",
          value: this.$t("api_key") // Tab Name
        },
        {
          route: "open_apis",
          value: this.$t("open_apis") // Tab Name
        }
        
      ];
    },
    formatsHeaders: function() {
      return dHeaders([
        {
          text: "Format",
          value: "format_name",
          type: DHeaderTypes.Text,
          selectable: true
        },
        {
          text: this.$t("album"),
          value: "album_single_merch",
          type: DHeaderTypes.Text,
          selectable: false
        },
        {
          text: this.$t("2_sides"),
          value: "two_sides_flag",
          type: DHeaderTypes.Checkbox,
          selectable: false
        },
        {
          text: this.$t("group"),
          value: "format_group",
          type: DHeaderTypes.TextField,
          selectable: false,
          placeholder: this.$t("group")
        }
      ]);
    },
    licenceStatusText: function() {
      return this.$route.query.licence_status_text || "";
    },
    dealTypeForm: function() {
      return createForms([
        createForm({
          required: true,
          name: "deal_type_name",
          showValidationIcons: true
        }),
        createForm({
          required: true,
          name: "deal_type_code",
          showValidationIcons: true
        })
      ]);
    },
    dealTypeFormData: function() {
      return {
        deal_type_id: this.$route.query.deal_type_id,
        deal_type_code: this.$route.query.deal_type_code,
        deal_type_name: this.$route.query.deal_type_name
      };
    },
    advance_type_name: function() {
      return this.$route.query.advance_type_name || "";
    },
    advance_type_id: function() {
      return this.$route.query.advance_type_id || "";
    }
  },
  methods: {
    ...mapActionObject(storeNS, sharingSettingsActions),

    fetchData: function() {
      this[ActionTypes.SharingData.FETCH.ALL]();
    },

    getRssData: function(artist_id) {
      this[ActionTypes.RssData.FETCH.SINGLE](artist_id);
    }
  }
};
</script>

<style lang="scss">
.cmp-settings-sharing-settings {
  background: white;
  padding: 8px;

  .dt-grid-layout {
    height: calc(100vh - 108px);
  }

  .invoice-notifications {
    .dt-checkbox-control {
      padding-top: 10px;
      padding-left: 3px;
      .dt-checkbox {
        max-width: 40px;
        margin-right: 10px;
        margin-top: 5px;
      }
      .dt-checkbox-label {
        flex: 1;
      }
    }
  }
}
</style>
